import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import { Switch, useTheme, Typography, Icon, Container } from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import BrushIcon from '@material-ui/icons/Brush';
import Brightness2Icon from '@material-ui/icons/Brightness2';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import Dropzone from '../ui/forms/Dropzone';
import { SubHeading } from '../ui/SubHeading';
import { DatabaseContext } from '../../contexts/DatabaseContext';
import { UserContext } from '../../contexts/UserContext';
import Color from 'color';

const AppearanceSettings = () => {
  const { apiUrl } = useContext(DatabaseContext);
  const { Site, handleThemeChange, uploadSiteLogo, userRole } = useContext(UserContext);
  const { siteCode, theme } = Site;

  const [preview, setPreview] = useState('');
  const { palette } = useTheme();

  const onDrop = async (files) => {
    const logo = files[0];
    try {
      const res = await uploadSiteLogo(siteCode, logo);
      setPreview(res);
    } catch (err) {
      console.log(err);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <>
      <SubHeading><BrushIcon style={Iconstyles}/> Appearance</SubHeading>
     
      <ToggleContainer>
        <ToggleTheme>
          <Typography
            variant='button'
            style={{
              marginRight: '5px',
              color:
                theme === 'dark'
                  ? palette.text.secondary
                  : palette.text.primary,
            }}
          >
            Light
          </Typography>
            <Brightness7Icon style={Iconstyles1}/>
          
          <Icon
            icon={<Brightness7Icon/>}//not working
            size='3x'
            color={
              theme === 'dark' ? palette.text.secondary : palette.success.main
            }
          />
          <Switch
            name='theme'
            onChange={handleThemeChange}
            checked={theme === 'dark'}
          /> {' '}
          <NightsStayIcon style={Iconstyles2}/>
          <Icon
            icon={<NightsStayIcon/>}
            size='3x'
            color={
              theme === 'light' ? palette.text.secondary : palette.success.main
            }
          />
          <Typography
            variant='button'
            style={{
              marginLeft: '5px',
              color:
                theme === 'light'
                  ? palette.text.secondary
                  : palette.text.primary,
            }}
          >
            Dark
          </Typography>
        </ToggleTheme>
      </ToggleContainer>
      
      <SubHeading><ImageIcon style={Iconstyles}/> Site Logo</SubHeading>
      {userRole === 'admin' ? (
      <Dropzone {...getRootProps()} drag={isDragActive}>
        <img src={preview || `${apiUrl}/logos/${siteCode}.png`} alt={'No Logo'} />
        <input {...getInputProps()} />
      </Dropzone>
      ):(
        <text>Please contact Monitor WA to add/update your school logo, send your logo to our support email : support@monitorwa.com.au</text>
      )}
    </>
  );
};

 const Iconstyles ={
   fontSize:'17px'
  }

   const Iconstyles1 ={
   fontSize:'40px',
   color:'#cccccc',
   marginRight:'5%'
  }

  const Iconstyles2 ={
   fontSize:'40px',
   //color:'#8CDD81',
   marginRight:'5%'
  }

const ToggleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  margin-top: 21px;
`;
const ToggleTheme = styled.div`
  display: flex;
  align-items: center;
`;


export default AppearanceSettings;
